import styled, { css } from "styled-components";

import Props from "./props";

const StyledHeader = styled.nav<Props>`
    height: 4.5rem;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    box-shadow: 2px 4px 10px ${props => props.theme.colors.black(0.2)};
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 0 1rem;
    z-index: 99;
    ${({ primary }) => {
        if (primary) {
            return css`
                background-color: ${props => props.theme.colors.primary(1)};
                color: ${props => props.theme.colors.primaryInvert(1)};
            `;
        } else {
            return css`
                background-color: ${props => props.theme.colors.white(1)};
                color: ${props => props.theme.colors.black(1)};
            `;
        }
    }}
    @media print {
        display: none;
    }
`;

export default StyledHeader;
